import { Actions, ActionsTypes } from '../actions/actions';

export interface State {
  availability: boolean;
  checking: boolean;
}

/* eslint-disable */
function getAvailabilityInitialState() {
  return {
    availability: true,
    checking: true
  };
}

const initialAvailabilityState = getAvailabilityInitialState();

/* eslint-disable */
export function reducer(state = initialAvailabilityState, action: Actions): State {
  switch (action.type) {
    case ActionsTypes.AvailabilityCheck: {
      return { ...getAvailabilityInitialState(), checking: true };
    }

    case ActionsTypes.AvailabilityChecked: {
      return { ...state, availability: action.payload, checking: false };
    }

    default:
      return state;
  }
}
